import { render, staticRenderFns } from "./AddEditFringeBenefits.vue?vue&type=template&id=3dbd5806&scoped=true"
import script from "./AddEditFringeBenefits.vue?vue&type=script&lang=js"
export * from "./AddEditFringeBenefits.vue?vue&type=script&lang=js"
import style0 from "./AddEditFringeBenefits.vue?vue&type=style&index=0&id=3dbd5806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd5806",
  null
  
)

export default component.exports